import React, { Fragment, Component } from "react";
import _ from 'lodash';
import styled from 'styled-components';
import { compose } from "redux";
import { connect } from "react-redux";
import {
    TextField,
    Checkbox,
  } from "@material-ui/core";
import MaterialDatePicker from "material-ui-pickers/DatePicker";
import { DEAL_KEY } from "store/state/fund";
import numberFormatter from 'utils/numberFormatter';
import {
  TwoDecimalPercentFormat,
  DollarAndCentFormat,
  FloatFormat,
} from 'components/Notifications/FormattedInputs';
import hedgeStatuses from "constants/hedgeStatus";

const StyledTextField = styled(TextField)`
  max-width: 130px;
`;
const ContainerDiv = styled.div`
width: 100%;
min-height: 100px;
`;

const GrayP = styled.p`
color: #777777;
`;

const TerminationTable = styled.table`
width: 100%
padding-left: 20px;
`;

const ACTIVE_HEDGE = hedgeStatuses.ACTIVE;

export class TerminateHedgeComponent extends Component {

    state = {
        hedgeNotionals : {},
        hedgeTerminationValues : {},
        hedgeTerminationDates : {},
        hedgesToExcludeFromTermination : {},
    }

    componentWillUnmount() {
        this.props.deal.hedges.forEach(hedge => {
            if(hedge.hedgeStatusId === ACTIVE_HEDGE){
                this.props.setHedgeProperty(hedge.id, "notional" , 
                    this.state.hedgeNotionals[hedge.id] || this.props.hedgeInfo[hedge.id] && this.props.hedgeInfo[hedge.id].notional ? this.props.hedgeInfo[hedge.id].notional : hedge.notional || 0);
                this.props.setHedgeProperty(hedge.id, "shouldTerminate" , this.isHedgeSetForTermination(hedge));
            }
        })
    }

    render() {
        const { deal } = this.props;
        return (
          <ContainerDiv>
            <GrayP>
                Please fill out the following information to terminate active hedges:
            </GrayP>
            {this.renderTerminateTable(deal)}
          </ContainerDiv>
        )
      }

      isHedgeSetForTermination = (hedge) => {
        return this.props.hedgeInfo[hedge.id] ? this.props.hedgeInfo[hedge.id].shouldTerminate == true || this.props.hedgeInfo[hedge.id].shouldTerminate === undefined : !this.state.hedgesToExcludeFromTermination[hedge.id];
      }
    
      renderTerminateTable = (deal) => {
        const rows = [];
        rows.push(
            <tr style={{fontWeight: "bold", textAlign: "center", marginBottom: "10px", marginTop: "10px"}}>
                 <td style={{width: "10%"}}>
                    Terminate?
                </td>
                <td style={{width: "30%"}}>
                </td>
                <td style={{width: "20%"}}>
                    Notional
                </td>
                <td style={{width: "20%"}}>
                    Termination Value
                </td>
                <td style={{width: "20%"}}>
                    Termination Date
                </td>
            </tr>
        );
        deal.hedges.forEach(hedge => {
            if(hedge.hedgeStatusId === ACTIVE_HEDGE){
                rows.push(
                    <tr style={{textAlign: "center"}}>
                        <td style={{width: "10%"}}>
                            <Checkbox 
                                checked = { this.isHedgeSetForTermination(hedge) }
                                onClick = { event => {
                                  const previouslyChecked = this.isHedgeSetForTermination(hedge) 
                                  let newExcludeList = this.state.hedgesToExcludeFromTermination;
                                  newExcludeList[hedge.id] = !previouslyChecked;
                                  this.setState({hedgesToExcludeFromTermination: newExcludeList});
                                  this.props.setHedgeProperty(hedge.id, "shouldTerminate" , !previouslyChecked);
                                }}
                            />
                        </td>
                        <td style={{width: "30%", fontWeight:"bold"}}>
                            {`${hedge.hedgeProvider.name} - ${hedge.hedgeType.value}`}
                        </td>
                        <td style={{width: "20%"}}>
                            {this.isHedgeSetForTermination(hedge) && 
                            renderInput({
                                type: "money",
                                value : this.state.hedgeNotionals[hedge.id] || this.props.hedgeInfo[hedge.id] && this.props.hedgeInfo[hedge.id].notional ? this.props.hedgeInfo[hedge.id].notional : hedge.notional || 0,
                                onBlur : (event) => {
                                    this.props.setHedgeProperty(hedge.id, "notional" , event.target.value.substring(1).replace(/,/g, "")); //substring to get rid of $
                                    let newNotionals = this.state.hedgeNotionals;
                                    newNotionals[hedge.id] = event.target.value.substring(1).replace(/,/g, "");
                                    this.setState({hedgeNotionals: newNotionals});
                                }
                            })
                        }
                        </td>
                        <td style={{width: "20%"}}>
                            {this.isHedgeSetForTermination(hedge) && 
                                renderInput({
                                    type: "money",
                                    value : this.state.hedgeTerminationValues[hedge.id] || this.props.hedgeInfo[hedge.id] && this.props.hedgeInfo[hedge.id].terminationValue ? this.props.hedgeInfo[hedge.id].terminationValue : undefined,
                                    onBlur : (event) => {
                                        this.props.setHedgeProperty(hedge.id, "terminationValue" , event.target.value.substring(1).replace(/,/g, "")); //substring to get rid of $
                                        let newTerminationValues = this.state.hedgeTerminationValues;
                                        newTerminationValues[hedge.id] = event.target.value.substring(1).replace(/,/g, "");
                                        this.setState({hedgeTerminationValues: newTerminationValues});
                                    }
                                })
                            }
                        </td>
                        <td style={{width: "20%"}}>
                            {this.isHedgeSetForTermination(hedge) && 
                                <MaterialDatePicker
                                    format = "MM/DD/YYYY"
                                    placeholder = "MM/DD/YYYY"
                                    value = {this.state.hedgeTerminationDates[hedge.id] || this.props.hedgeInfo[hedge.id] && this.props.hedgeInfo[hedge.id].terminationDate ? this.props.hedgeInfo[hedge.id].terminationDate : null}
                                    style = {{ width: "75%"}}
                                    onChange = { event => {
                                        let newDatesObject = this.state.hedgeTerminationDates;
                                        newDatesObject[hedge.id] = event;
                                        this.setState({hedgeTerminationDates: newDatesObject});
                                        this.props.setHedgeProperty(hedge.id, "terminationDate", event);
                                    }}
                                />
                            }
                        </td>
                    </tr>
                );
            }
        });
        return(
        <TerminationTable>
            {rows}
        </TerminationTable>
        );
      }

}

const renderInput = ({type, defaultValue, onChange, onBlur, style, internalLabel, value}) => {
    let inputProps = {
    style:{
        textAlign: "center", 
        transition: '0.3s',
        }
    };
    switch(type){
        case 'money':
            inputProps.inputComponent = DollarAndCentFormat;
            break;   
        case 'percent':
            inputProps.inputComponent = TwoDecimalPercentFormat;
            break;
        case 'integer':
            inputProps.inputComponent = FloatFormat;
        default:
            break;
    }
    return (
        <StyledTextField 
            defaultValue = {defaultValue}
            InputProps = {inputProps}
            onChange = {onChange}
            onBlur = {onBlur}
            label = {internalLabel}
            style={style}
            value = {value}
        />
    )
}

function mapStateToProps({ deal }) {
    return {
        deal: deal.closeRefiModelInfo,
    };
  }
  
  export default compose(
  connect(
    mapStateToProps,
    {
      
    }
  )
  )(TerminateHedgeComponent);